var $ = require('jquery');
var oldAjax = $.ajax;

function newAjax() {
  var args = Array.prototype.slice.apply(arguments);
  var headers, settings, lcCsrf;

  var header = $('meta[name=csrf-header]').attr('content');
  var token = $('meta[name=csrf-token]').attr('content');

  settings = args[0];
  if (args.length === 2) {
    settings = args[1];
  }

  lcCsrf = settings.lcCsrf;
  if (lcCsrf !== false && header && token && header !== '' && token !== '') {
    headers = settings.headers || {};
    headers[header] = token;
    settings.headers = headers;
  }

  return oldAjax.apply($, args);
}

$.ajax = newAjax;
module.exports = $;

